/**
 * The 28-day IELTS track: four weeks (know the test, build skills, strategy and speed, exam mode), each running
 * Listening, Reading, Writing Task 1, Speaking, Writing Task 2, a practice test and a review day. Original copy,
 * written for this product; keep it free of any publisher's material.
 */
import type { TrackDay } from './types';

export const TRACK_DAYS: readonly TrackDay[] = [
  // Week 1: know the test
  {
    skill: 'LISTENING',
    title: { uz: 'Listening qanday tuzilgan', ru: 'Как устроен Listening', en: 'How Listening works' },
    body: {
      uz: '4 qism, 40 savol, taxminan 30 daqiqa, har bir yozuv faqat bir marta eshittiriladi. Bugun bitta qismni bajaring: yozuvdan oldin savollarni o‘qib, har bir bo‘sh joyga qanday so‘z kerakligini (son, ism, fe’l) belgilab chiqing.',
      ru: '4 части, 40 вопросов, около 30 минут, каждая запись звучит один раз. Сегодня выполните одну часть: до записи прочитайте вопросы и отметьте, какое слово нужно в каждом пропуске (число, имя, глагол).',
      en: 'Four parts, 40 questions, about 30 minutes, and each recording is played once. Today do one part: before it starts, read the questions and mark what kind of word each gap needs (number, name, verb).',
    },
  },
  {
    skill: 'READING',
    title: { uz: 'Reading qanday tuzilgan', ru: 'Как устроен Reading', en: 'How Reading works' },
    body: {
      uz: '3 matn, 40 savol, 60 daqiqa, javoblarni ko‘chirish uchun qo‘shimcha vaqt berilmaydi. Bugun bitta matnni 20 daqiqada bajaring: savollardan oldin har bir abzasning asosiy fikrini tez ko‘z yugurtirib aniqlang.',
      ru: '3 текста, 40 вопросов, 60 минут, дополнительного времени на перенос ответов нет. Сегодня решите один текст за 20 минут: до вопросов бегло просмотрите текст и уловите главную мысль каждого абзаца.',
      en: 'Three passages, 40 questions, 60 minutes, with no extra time to transfer answers. Today do one passage in 20 minutes: before the questions, skim for the main idea of each paragraph.',
    },
  },
  {
    skill: 'WRITING_TASK1',
    title: { uz: 'Writing Task 1: to‘rt qism', ru: 'Writing Task 1 из четырёх частей', en: 'Writing Task 1 in four parts' },
    body: {
      uz: 'Kamida 150 so‘z, taxminan 20 daqiqa: savolni boshqa so‘zlar bilan beruvchi kirish, asosiy tendensiyalar haqida umumiy xulosa (overview) va raqamlar keltirilgan ikkita abzas. Bugun bitta grafik uchun faqat kirish va overview yozing.',
      ru: 'Не менее 150 слов, около 20 минут: вступление, перефразирующее задание, общий обзор главных тенденций (overview) и два абзаца с цифрами. Сегодня напишите только вступление и overview для одного графика.',
      en: 'At least 150 words in about 20 minutes: an introduction that paraphrases the question, an overview of the main trends, and two body paragraphs with figures. Today write only the introduction and overview for one chart.',
    },
  },
  {
    skill: 'SPEAKING',
    title: { uz: 'Speakingning uch qismi', ru: 'Три части Speaking', en: 'The three parts of Speaking' },
    body: {
      uz: '1-qism: o‘zingiz haqingizda qisqa savollar. 2-qism: 1 daqiqa tayyorgarlikdan keyin 2 daqiqalik nutq. 3-qism: mavzu bo‘yicha suhbat. Bugun 1-qismning beshta savoliga ovoz chiqarib javob bering, har biriga sabab yoki misol bilan 2–3 gap.',
      ru: 'Часть 1: короткие вопросы о вас. Часть 2: двухминутный монолог после минуты подготовки. Часть 3: обсуждение темы. Сегодня ответьте вслух на пять вопросов части 1, по 2–3 предложения с причиной или примером.',
      en: 'Part 1 is short questions about you, Part 2 a two-minute talk after one minute of notes, Part 3 a discussion. Today answer five Part 1 questions out loud, each in two or three sentences with a reason or example.',
    },
  },
  {
    skill: 'WRITING_TASK2',
    title: { uz: 'Writing Task 2: berilgan savolga javob bering', ru: 'Writing Task 2: отвечайте на заданный вопрос', en: 'Writing Task 2: answer the question asked' },
    body: {
      uz: 'Kamida 250 so‘z, taxminan 40 daqiqa, bahoda Task 1 dan ikki baravar og‘irroq. Bugun bitta savolni oling, turini aniqlang (fikr, ikki tomonni muhokama, muammo va yechim, afzallik va kamchilik) va aniq tezis gapini yozing.',
      ru: 'Не менее 250 слов, около 40 минут, в оценке весит вдвое больше Task 1. Сегодня возьмите одно задание, определите его тип (мнение, обсуждение двух сторон, проблема и решение, плюсы и минусы) и напишите чёткий тезис.',
      en: 'At least 250 words in about 40 minutes, and it counts twice as much as Task 1. Today take one question, name its type (opinion, discuss both views, problem and solution, advantages and disadvantages) and write a clear thesis sentence.',
    },
  },
  {
    skill: 'PRACTICE',
    title: { uz: 'Birinchi to‘liq test', ru: 'Первый полный тест', en: 'Your first full test' },
    body: {
      uz: 'Boshlang‘ich darajangizni bilish uchun imtihon sharoitida to‘liq IELTS testini topshiring: to‘xtamang, lug‘atga qaramang. Natija keyingi haftalarda nimaga ko‘proq vaqt ajratishni ko‘rsatadi.',
      ru: 'Пройдите полный тест IELTS в условиях экзамена, чтобы узнать стартовый уровень: без пауз и без словаря. Результат покажет, чему уделить больше времени в следующие недели.',
      en: 'Take a full IELTS practice test in exam conditions to find your starting band: no pauses, no dictionary. The result shows where the coming weeks should go.',
    },
  },
  {
    skill: 'REVIEW',
    title: { uz: 'Haftani tahlil qiling', ru: 'Разбор недели', en: 'Look back at the week' },
    body: {
      uz: 'Bu haftadagi xato javoblaringizni ko‘rib chiqing va har biri nega xato bo‘lganini yozing: noto‘g‘ri o‘qilgan, so‘z notanish, vaqt yetmagan. 10 ta yangi so‘z o‘rganing. Bugun qisqa mashg‘ulot yetarli.',
      ru: 'Просмотрите неверные ответы за неделю и запишите причину каждой ошибки: невнимательно прочитал, незнакомое слово, не хватило времени. Выучите 10 новых слов. Сегодня достаточно короткого занятия.',
      en: 'Go through this week’s wrong answers and note why each one was wrong: misread, unknown word, or out of time. Learn 10 new words. A short session is enough today.',
    },
  },

  // Week 2: build skills
  {
    skill: 'LISTENING',
    title: { uz: 'Imlo va raqamlar', ru: 'Орфография и числа', en: 'Spelling and numbers' },
    body: {
      uz: 'Listeningda ko‘p ball imlo, ko‘plik qo‘shimchasi va raqamlar tufayli yo‘qotiladi. Bugun 1-qism turidagi blankalarni mashq qiling: sana, telefon raqami va ismlarni aynan aytilganidek yozing.',
      ru: 'В Listening много баллов теряется на орфографии, множественном числе и цифрах. Сегодня потренируйтесь на бланках как в части 1: записывайте даты, телефоны и имена точно так, как их диктуют.',
      en: 'Many Listening marks are lost on spelling, plurals and numbers. Today practise Part 1 style forms: write dates, phone numbers and names exactly as they are spelled out.',
    },
  },
  {
    skill: 'READING',
    title: { uz: 'True / False / Not Given', ru: 'True / False / Not Given', en: 'True / False / Not Given' },
    body: {
      uz: 'False: matnda buning aksi aytilgan. Not Given: matnda bu haqda hech narsa yo‘q. Bugun shu turdagi bitta to‘plamni bajaring va har bir javobni isbotlovchi gapni matndan toping.',
      ru: 'False: в тексте сказано обратное. Not Given: в тексте об этом ничего нет. Сегодня решите один такой набор и для каждого ответа найдите строку в тексте, которая его доказывает.',
      en: 'False means the text says the opposite; Not Given means the text does not say. Today do one set of these and, for each answer, find the line in the text that proves it.',
    },
  },
  {
    skill: 'WRITING_TASK1',
    title: { uz: 'O‘zgarishni tasvirlash', ru: 'Описание тенденций', en: 'Describing trends' },
    body: {
      uz: 'O‘zgarishni bildiruvchi fe’l va otlarni o‘rganing (rise, fall, fluctuate, a sharp increase) va raqamlarni solishtirishni mashq qiling. Bugun bitta chiziqli grafikni 150 so‘zda, ulardan kamida beshtasini ishlatib tasvirlang.',
      ru: 'Выучите глаголы и существительные изменения (rise, fall, fluctuate, a sharp increase) и способы сравнивать цифры. Сегодня опишите один линейный график в 150 словах, используя хотя бы пять из них.',
      en: 'Learn the verbs and nouns of change (rise, fall, fluctuate, a sharp increase) and how to compare figures. Today describe one line graph in 150 words using at least five of them.',
    },
  },
  {
    skill: 'SPEAKING',
    title: { uz: '2-qism: uzun nutq', ru: 'Часть 2: монолог', en: 'Part 2: the long turn' },
    body: {
      uz: 'Tayyorgarlik daqiqasida 4 ta kalit so‘z yozing: nima, qachon yoki qayerda, kim, nega muhim. Bugun ikkita kartochka bo‘yicha o‘zingizni yozib oling va to‘liq 2 daqiqa gapirganingizni tekshiring.',
      ru: 'За минуту подготовки запишите 4 ключевых слова: что, когда или где, кто, почему это важно. Сегодня запишите себя на две карточки и проверьте, что говорили все 2 минуты.',
      en: 'Use your minute to note four keywords: what, when or where, who, and why it matters. Today record yourself on two cue cards and check that you spoke for the full two minutes.',
    },
  },
  {
    skill: 'WRITING_TASK2',
    title: { uz: 'Fikrni rivojlantiruvchi abzas', ru: 'Абзац, который развивает мысль', en: 'Paragraphs that develop an idea' },
    body: {
      uz: 'Har bir abzasda bitta asosiy fikr, uning izohi, misol va savolga qaytuvchi xulosa gapi bo‘lsin. Bugun bitta Task 2 savoli uchun ikkita asosiy abzas yozing.',
      ru: 'В каждом абзаце одна главная мысль, её объяснение, пример и фраза, возвращающая к вопросу. Сегодня напишите два основных абзаца к одному заданию Task 2.',
      en: 'Each body paragraph has one main idea, an explanation, an example and a line that links back to the question. Today write two body paragraphs for one Task 2 question.',
    },
  },
  {
    skill: 'PRACTICE',
    title: { uz: 'Vaqt bilan Reading', ru: 'Reading на время', en: 'Reading against the clock' },
    body: {
      uz: 'To‘liq Reading testini 60 daqiqada bajaring va qaysi savol turi eng ko‘p vaqt yoki ball olganini yozib qo‘ying.',
      ru: 'Пройдите полный Reading за 60 минут и запишите, какой тип вопросов отнял больше всего времени или баллов.',
      en: 'Do a full Reading test in 60 minutes and note which question type cost you the most time or marks.',
    },
  },
  {
    skill: 'REVIEW',
    title: { uz: 'Dam olish va takrorlash', ru: 'Отдых и повторение', en: 'Rest and review' },
    body: {
      uz: 'Xatolaringiz va yangi so‘zlarni takrorlang. Bugun faqat qisqa mashg‘ulot: dam olish ham reja qismi.',
      ru: 'Повторите ошибки и новые слова. Сегодня только короткое занятие: отдых тоже часть плана.',
      en: 'Go over your mistakes and new words. Keep it short today: rest is part of the plan.',
    },
  },

  // Week 3: strategy and speed
  {
    skill: 'LISTENING',
    title: { uz: 'Xarita va test savollari', ru: 'Карты и вопросы с выбором', en: 'Maps and multiple choice' },
    body: {
      uz: 'Xaritada so‘zlovchini aniq boshlang‘ich nuqtadan kuzating. Tanlovli savollarda chalg‘ituvchi javob ko‘pincha avval aytiladi, keyin tuzatiladi. Bugun 2- va 3-qismlardan bittadan mashq bajaring.',
      ru: 'На карте следите за говорящим от точки отсчёта. В вопросах с выбором ловушку часто называют первой, а потом исправляют. Сегодня решите по одному заданию из частей 2 и 3.',
      en: 'On a map, follow the speaker from a fixed starting point. In multiple choice, a distractor is often said first and then corrected. Today do one Part 2 and one Part 3 practice.',
    },
  },
  {
    skill: 'READING',
    title: { uz: 'Sarlavhalarni moslash', ru: 'Подбор заголовков', en: 'Matching headings' },
    body: {
      uz: 'Har bir abzasning birinchi va oxirgi gapini o‘qing: sarlavha abzasning asosiy fikriga mos keladi, tafsilotga emas. Bugun sarlavha moslash to‘plamini 15 daqiqadan kamroq vaqtda bajaring.',
      ru: 'Читайте первое и последнее предложения абзаца: заголовок соответствует главной мысли, а не детали. Сегодня решите набор на подбор заголовков быстрее чем за 15 минут.',
      en: 'Read the first and last sentence of each paragraph: a heading matches the main idea, not a detail. Today do a matching headings set in under 15 minutes.',
    },
  },
  {
    skill: 'WRITING_TASK1',
    title: { uz: 'Xarita, jarayon va aralash diagrammalar', ru: 'Карты, процессы и смешанные графики', en: 'Maps, processes and mixed charts' },
    body: {
      uz: 'Jarayonni bosqichma-bosqich, majhul nisbat (passive) bilan tasvirlang. Xaritada oldingi va keyingi holatni solishtiring. Bugun bitta jarayon yoki xarita bo‘yicha hisobot yozing.',
      ru: 'Процесс описывайте по шагам в пассивном залоге, на картах сравнивайте «до» и «после». Сегодня напишите один отчёт по процессу или карте.',
      en: 'Describe a process stage by stage using the passive; on maps, compare before and after. Today write one process or map report.',
    },
  },
  {
    skill: 'SPEAKING',
    title: { uz: '3-qism: javobni kengaytiring', ru: 'Часть 3: развивайте ответ', en: 'Part 3: extend your answers' },
    body: {
      uz: 'Javob bering, izohlang, misol keltiring, boshqa tomonini ham ko‘rib chiqing. Bugun 3-qismning oltita savoliga har biriga taxminan 40 soniya javob bering.',
      ru: 'Ответьте, объясните, приведите пример, рассмотрите другую сторону. Сегодня ответьте на шесть вопросов части 3, примерно по 40 секунд на каждый.',
      en: 'Answer, explain, give an example, then consider the other side. Today answer six Part 3 questions for about 40 seconds each.',
    },
  },
  {
    skill: 'WRITING_TASK2',
    title: { uz: 'Bog‘liqlik va bog‘lovchilar', ru: 'Связность и связки', en: 'Coherence and linking' },
    body: {
      uz: 'Bog‘lovchilarni bezak uchun emas, mantiq uchun ishlating: however, moreover, as a result kabilarni almashtirib turing va this, such kabi ishora so‘zlardan foydalaning. Bugun eski inshoingizni bog‘lanishini yaxshilab qayta yozing.',
      ru: 'Связки нужны для логики, а не для украшения: чередуйте however, moreover, as a result и используйте отсылки вроде this, such. Сегодня перепишите старое эссе, улучшив связки.',
      en: 'Use linking words for logic, not decoration: vary however, moreover and as a result, and use reference words such as this and such. Today rewrite an old essay with better links.',
    },
  },
  {
    skill: 'PRACTICE',
    title: { uz: 'To‘liq Listening testi', ru: 'Полный Listening', en: 'A full Listening test' },
    body: {
      uz: 'Imtihon sharoitida 30 daqiqalik to‘liq Listening testini topshiring, keyin har bir javobning imlosini tekshiring.',
      ru: 'Пройдите полный Listening за 30 минут в условиях экзамена, затем проверьте орфографию каждого ответа.',
      en: 'Take a full Listening test in exam conditions, then check the spelling of every answer.',
    },
  },
  {
    skill: 'REVIEW',
    title: { uz: 'Xatolar ustida ishlash', ru: 'Работа над ошибками', en: 'Work on your mistakes' },
    body: {
      uz: 'Uch haftalik xatolaringizdan eng ko‘p takrorlanganini tanlang va unga bugun alohida e’tibor bering. 10 ta so‘zni takrorlang.',
      ru: 'Выберите самую частую ошибку за три недели и уделите ей сегодня отдельное внимание. Повторите 10 слов.',
      en: 'Pick the mistake you made most often over three weeks and give it its own session today. Revise 10 words.',
    },
  },

  // Week 4: exam mode
  {
    skill: 'LISTENING',
    title: { uz: '4-qism: ma’ruza', ru: 'Часть 4: лекция', en: 'Part 4: the lecture' },
    body: {
      uz: '4-qismda o‘rtada tanaffus bo‘lmaydi. Yo‘naltiruvchi so‘zlarga quloq soling: firstly, turning to, in conclusion. Bugun bitta 4-qism mashqini bajaring.',
      ru: 'В части 4 нет паузы посередине. Следите за словами-указателями: firstly, turning to, in conclusion. Сегодня решите одно задание части 4.',
      en: 'Part 4 has no break in the middle. Follow the signpost words: firstly, turning to, in conclusion. Today do one Part 4 practice.',
    },
  },
  {
    skill: 'READING',
    title: { uz: 'Vaqt rejasi', ru: 'План по времени', en: 'A time plan' },
    body: {
      uz: 'Matnlarga taxminan 17, 20 va 23 daqiqa ajrating, chunki oxirgisi eng qiyini. Hech bir javobni bo‘sh qoldirmang. Bugun shu reja bilan to‘liq Reading testini bajaring.',
      ru: 'Отведите на тексты примерно 17, 20 и 23 минуты, последний самый сложный. Не оставляйте пустых ответов. Сегодня пройдите полный Reading по этому плану.',
      en: 'Give the passages about 17, 20 and 23 minutes, since the last is the hardest, and never leave an answer blank. Today do a full Reading test with that plan.',
    },
  },
  {
    skill: 'WRITING_TASK1',
    title: { uz: 'Vaqt bilan Task 1', ru: 'Task 1 на время', en: 'Timed Task 1' },
    body: {
      uz: '20 daqiqada Task 1 yozing. Oxirida tekshiring: overview bormi, shaxsiy fikr qo‘shilmaganmi, raqamlar to‘g‘rimi.',
      ru: 'Напишите Task 1 за 20 минут. В конце проверьте: есть ли overview, нет ли личного мнения, верны ли цифры.',
      en: 'Write Task 1 in 20 minutes. Then check: is there an overview, no personal opinion, and are the figures right?',
    },
  },
  {
    skill: 'SPEAKING',
    title: { uz: 'Mukammallikdan ko‘ra ravonlik', ru: 'Беглость важнее идеала', en: 'Fluency over perfection' },
    body: {
      uz: 'Gapirishda davom eting, xatoni qisqa tuzating, yodlangan javoblardan qoching: imtihonchi buni sezadi. Bugun do‘stingiz bilan yoki yozib olib 11–14 daqiqalik to‘liq Speaking mashqini bajaring.',
      ru: 'Продолжайте говорить, исправляйтесь коротко, избегайте заученных ответов: экзаменатор это замечает. Сегодня проведите полный Speaking на 11–14 минут с другом или под запись.',
      en: 'Keep talking, correct yourself briefly and avoid memorised answers, which examiners notice. Today run a full 11 to 14 minute Speaking mock with a friend or a recording.',
    },
  },
  {
    skill: 'WRITING_TASK2',
    title: { uz: 'Vaqt bilan Task 2', ru: 'Task 2 на время', en: 'Timed Task 2' },
    body: {
      uz: '40 daqiqa: 5 daqiqa reja, 30 daqiqa yozish, 5 daqiqa tekshirish. Bugun shu tartibda bitta insho yozing.',
      ru: '40 минут: 5 на план, 30 на текст, 5 на проверку. Сегодня напишите одно эссе в таком порядке.',
      en: 'Forty minutes: five to plan, thirty to write, five to check. Today write one essay that way.',
    },
  },
  {
    skill: 'PRACTICE',
    title: { uz: 'To‘liq sinov imtihoni', ru: 'Полный пробный экзамен', en: 'A full mock' },
    body: {
      uz: 'Butun testni bir o‘tirishda topshiring va natijani birinchi haftadagi bilan solishtiring.',
      ru: 'Пройдите весь тест за один раз и сравните результат с первой неделей.',
      en: 'Take the whole test in one sitting and compare the result with your first week.',
    },
  },
  {
    skill: 'REVIEW',
    title: { uz: 'Imtihondan oldin', ru: 'Перед экзаменом', en: 'Before exam day' },
    body: {
      uz: 'Yengil takrorlash, yaxshi uyqu va imtihon kuni qoidalarini bilish. Agar imtihoningiz keyinroq bo‘lsa, ertadan yo‘l yangi aylana bilan qaytadan boshlanadi.',
      ru: 'Лёгкое повторение, хороший сон и знание правил экзаменационного дня. Если экзамен позже, завтра курс начнётся заново, новым кругом.',
      en: 'Light review, a good night’s sleep, and know the test-day rules. If your exam is later, the track starts again tomorrow as a new round.',
    },
  },
];
